/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, price: NonNullable<unknown>, total: NonNullable<unknown> }} Sub_Addons_Copilot_CalcInputs */



/**
* | output |
* | --- |
* | "{seats} seats × €{price} = €{total}/mo" |
*
* @param {Sub_Addons_Copilot_CalcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_copilot_calc = /** @type {((inputs: Sub_Addons_Copilot_CalcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Copilot_CalcInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} Plätze × €${i?.price} = €${i?.total}/Mo.`)
	return /** @type {LocalizedString} */ (`${i?.seats} seats × €${i?.price} = €${i?.total}/mo`)
});